<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Mei Story" bg="/images/board/story/visual.jpg" />
        </template>

        <sub-section class="page-section--first page-section--last">
            <board-list code="story" locale="ko" skin="card-ko" v-if="!$route.params._board" />
            <board-view code="story" :_id="$route.params._board" skin="card-ko" v-else />
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";

import BoardList from '@/components/client/board/board-list.vue';
import BoardView from '@/components/client/board/board-view.vue';

export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
        BoardList,
        BoardView,
    },
}
</script>